/*
 * @Description 组件 进场情况
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- index-sub-item start -->
	<div class="index-sub-item sub-item-approach">
		<div class="sub-items-box-top"></div>
		
		<!-- sub-approach-box -->
		<div class="sub-items-box-center sub-approach-box">
			<div class="index-sub-title">进场分析</div>
			<!-- sub-approach-content start -->
			<div class="abs-center sub-approach-content">
				<span class="approach-content-icon">
					<i class="content-icon-user"></i>
					<i class="content-icon-car"></i>
				</span>
				<!-- sub-approach-item start -->
				<div v-for="(item, index) in dataList" :key="index" :class="{'sub-approach-item': true, 'cursor-pointer': item.num > 0}" @click="handleItemBtn(item)" :title="spliceTitle(item)">
					<span class="approach-item-title">{{item.orgtext}}进场</span>
					<div class="approach-item-content">
						<span class="approach-item-num">{{item.num_user}}</span>
						<span class="approach-item-num">{{item.num_car}}</span>
					</div>
				</div>
				<!-- sub-approach-item end -->
				
			</div>
			<!-- sub-approach-content end -->
		</div>
		<!-- sub-approach-box -->
		
		<div class="sub-items-box-bottom"></div>
	</div>
	<!-- index-sub-item end -->
</template>

/* JS */
<script>
	// API 进场
	import ApiApproach from '@/request/api-approach'
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "IndApproach",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 进场人数
				dataList: [
					{num_user: 0, num_car: 0, orgtext: '当前', type: 'current'},
					{num_user: 0, num_car: 0, orgtext: '当天', type: 'today'},
					{num_user: 0, num_car: 0, orgtext: '历史', type: 'history'},
				],
				// 计时器 刷新数据
				timer_init_data: null,
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 开启订阅消息
			this.startSubscribes();
			
			// 数据查询
			this.searchData();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 取消订阅消息
			this.endSubscribes();
			// 清除计时器
        	this.endTimers();
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des 清除计时器
			 * @Auth
			 * @Date
			 */
			endTimers() {
				// 清除计时器
				if (this.timer_init_data != null) {
					clearTimeout(this.timer_init_data);
					this.timer_init_data = null;
				}
			},
			
			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date
			 */
			startSubscribes() {
				// 订阅消息 详情页
				this.sub_dataChange = this.$pubsub.subscribe('ApproachChange', (name, data) => {
					// 数据查询
					this.searchData();
				});
			},
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date
			 */
			endSubscribes() {
				//取消订阅 详情页
				this.$pubsub.unsubscribe(this.sub_dataChange);
			},
			
			//========================== 订阅消息 end ==========================
			
			/**
			 * @Des 点击条目btn
			 * @Auth
			 * @Date
			 */
			handleItemBtn(row) {
				// 非当天 中止
				if (!this.$checkEmpty(row) && !this.$checkEmpty(row.type) && !(row.num_user > 0 || row.num_car > 0)) {
					return false;
				}
				
				// 路由 跳转
				this.$router.replace({path: ('/manager/tunnel/today')}, ()=>{}, ()=>{});
				
				return false;
				// 参数
				let filter = {};
				if (!this.$checkEmpty(row) && !this.$checkEmpty(row.type)) {
					filter.activeName = row.type;
				}
				
				// 点击条目
				this.handleDetailBtn('Approach', '当天人员进场情况', filter);
			},
			
			/**
			 * @Des 点击条目
			 * @Auth
			 * @Date
			 */
			handleDetailBtn(detailSubRef, detailSubName, detailFilters) {
				// 发布消息 详情页
				this.$pubsub.publish('handleDetail', {showDetailFlag: true, detailSubRef: detailSubRef, detailSubName: detailSubName, detailFilters: detailFilters});
			},
			
			/**
			 * @Des title 拼接
			 * @Auth
			 * @Date
			 */
			spliceTitle(row) {
				let title = row.orgtext + '进场人员：' +row.num_user +'\n' + row.orgtext + '进场车辆：' +row.num_car;
				if (row.num_user > 0 || row.num_car > 0) {// row.type != 'current'
					title += '\n（点击查看当天进场详情）';
				}
				return title;
			},
			
			//========================== 数据查询 start ==========================
			/**
			 * @Des 查询 数据查询
			 * @Auth 
			 * @Date 
			 */
			searchData(){
				// 清除计时器
				if (this.timer_init_data != null) {
					clearTimeout(this.timer_init_data);
					this.timer_init_data = null;
				}
				
				this.dataList.forEach((row, index) => {
					// 查询 数据查询 current today history
					this.searchApproachData(index, 1);// 人员
					this.searchApproachData(index, 3);// 车辆
				});
				
				// 计时器 更新数据
				this.timer_init_data = setTimeout(() => {
					// 查询 数据查询
					this.searchData();
				}, 1*60*1000);
			},// searchData
			
			
			
			/**
			 * @Des 查询 数据查询 current today history
			 * @Auth 
			 * @Date 
			 */
			searchApproachData(index, bdType) {
				let row = Object.assign({}, this.dataList[index]);
				// 交互 参数
				let formData = {projectId: this.$store.state.currentProjectId};
				// 当前
				if (row.type == 'current') {
					formData.status = 1;
				}
				// 当天
				if (row.type == 'today') {
					let today = this.$moment(new Date()).format('YYYY-MM-DD');
					formData.startDate = [today, '00:00:00'].join(' ');
					formData.endDate = [today, '23:59:59'].join(' ');
				}
				
				// 绑定类型
				if (bdType) {
					formData['bindingType'] = bdType;
				}
				
				this.$request.postJsonRequest(ApiApproach.getUserApi, formData).then(result => {
					// 成功
					if (result.code == 0 && !this.$checkEmpty(result.data)) {
						let data = Object.assign([], result.data);
						
						// 进场人数 当前
						if (bdType == 3) {
							this.dataList[index].num_car = data.length;
						} else {
							this.dataList[index].num_user = data.length;
						}
					}
				}).catch(error => {
					console.error('查询进场数据异常', ApiApproach.getUserApi, error);
				})
			},// searchApproachData
			//========================== 数据查询 end ==========================
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/IndexItems/IndApproach.vue